import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { lenderNames, loanHeader, withdrawReasons } from '../../data/withdraw';
import { DeadForm, WithdrawReason } from '../../types/withdraw';
import { inputClasses } from '../../utils/styles';
import { Expand } from '../ui/Expand';
import { FormField } from '../ui/FormField';
import { ReAppSection } from './ReAppSection';
import { LenderSyncBanner } from './LenderSyncBanner';
interface DeadPathStepProps {
  form: DeadForm;
  onChange: (patch: Partial<DeadForm>) => void;
}
export function DeadPathStep({
  form,
  onChange
}: DeadPathStepProps) {
  const firstName = loanHeader.borrower.split(' ')[0];
  return <div className="space-y-6" data-id="element-40" data-mp="2y90prckd3pxj">
      <div data-id="element-41" data-mp="2t8w5rck8wd2k">
        <h3 className="text-lg font-bold tracking-tight text-slate-900" data-id="element-42" data-mp="2t71lm0gssozj">Withdraw details</h3>
        <p className="mt-1 text-sm text-slate-500" data-id="element-43" data-mp="1msamo2b8je85">Tell us why {firstName}'s file is closing so reporting stays accurate.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-[1.5fr_1fr]" data-id="element-44" data-mp="1hrmo8vkofv3w">
        <FormField label="Withdraw reason" htmlFor="withdraw-reason" required data-id="element-45" data-mp="2rbt70c5n9746">
          <div className="relative" data-id="element-46" data-mp="2ve6fh8brzj4n">
            <select id="withdraw-reason" value={form.reason} onChange={e => onChange({
            reason: e.target.value as WithdrawReason
          })} className={`${inputClasses} appearance-none pr-10 ${form.reason ? '' : 'text-slate-400'}`} data-id="element-47" data-mp="2vcd45fq7waqb">
              <option value="" disabled data-id="element-48" data-mp="27nahtukn1tph">
                Select a reason
              </option>
              {withdrawReasons.map(r => <option key={r} value={r} className="text-slate-900" data-id="element-49" data-mp="2cgn0lo2mz6ab">
                  {r}
                </option>)}
            </select>
            <ChevronDownIcon className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" data-id="element-50" data-mp="23na1u5hw5agb" />
          </div>
        </FormField>
        <FormField label="Withdraw date" htmlFor="withdraw-date" required data-id="element-51" data-mp="1tnj4lw1y4hcj">
          <input id="withdraw-date" type="date" value={form.withdrawDate} onChange={e => onChange({
          withdrawDate: e.target.value
        })} className={inputClasses} data-id="element-52" data-mp="1akhbnn1rkdfc" />
        </FormField>
      </div>

      <Expand show={form.reason === 'Went With Another Lender'} data-id="element-53" data-mp="vv1lo9a24c0p">
        <div className="pb-1" data-id="element-54" data-mp="vsoz1itctdhb">
          <ReAppSection form={form} currentLender={lenderNames[form.lenderVariant]} onChange={onChange} data-id="element-55" data-mp="1tia7k5dyzn38" />
        </div>
      </Expand>

      <FormField label="Notes" htmlFor="withdraw-notes" hint="Optional · visible to your team only" data-id="element-56" data-mp="1oks5myyde84q">
        <textarea id="withdraw-notes" rows={3} value={form.notes} onChange={e => onChange({
        notes: e.target.value
      })} placeholder="Add any context for your team…" className={`${inputClasses} h-auto resize-none py-3`} data-id="element-57" data-mp="1jj2pj4waj49s" />
      </FormField>

      <LenderSyncBanner form={form} onChange={onChange} data-id="element-58" data-mp="34kr0qnb8obg" />
    </div>;
}